import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "@/components/DashboardLayout";
import api from "@/lib/api";
import { STATUS_LABEL, STATUS_BADGE, RISK_BADGE, LOAN_PRODUCTS } from "@/lib/loanProducts";

const fmt = (v) => `$${Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
const productTitle = (key) => LOAN_PRODUCTS.find((p) => p.key === key)?.title || key;

export default function MyApplications() {
  const [apps, setApps] = useState([]);
  useEffect(() => {
    api.get("/applications/me").then(({ data }) => setApps(data || []));
  }, []);

  return (
    <DashboardLayout role="client">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-semibold text-ink sm:text-3xl">My applications</h1>
          <p className="mt-1 text-sm text-ink-soft">Track each application from submission to decision.</p>
        </div>
        <Link to="/apply" className="rounded-full bg-[#E87722] px-4 py-2 text-sm font-semibold text-white hover:bg-[#cc6517]" data-testid="myapps-new-btn">
          + New application
        </Link>
      </div>

      <div className="overflow-hidden rounded-xl border border-[#E5E2DE] bg-white">
        <div className="hidden grid-cols-12 gap-4 border-b border-[#E5E2DE] bg-[#F9F6F0] px-5 py-3 text-xs font-semibold uppercase tracking-wider text-ink-muted md:grid">
          <div className="col-span-4">Product</div>
          <div className="col-span-2">Amount</div>
          <div className="col-span-2">Term</div>
          <div className="col-span-2">Risk</div>
          <div className="col-span-2">Status</div>
        </div>
        {apps.length === 0 && (
          <div className="px-5 py-10 text-center text-sm text-ink-soft">
            No applications yet. <Link to="/apply" className="font-semibold text-[#5B2C82] hover:text-[#E87722]">Apply for your first loan →</Link>
          </div>
        )}
        {apps.map((a) => (
          <div key={a.id} data-testid={`myapps-row-${a.id}`} className="grid grid-cols-1 gap-2 border-b border-[#E5E2DE] px-5 py-4 last:border-b-0 md:grid-cols-12 md:gap-4">
            <div className="md:col-span-4">
              <div className="font-heading text-sm font-semibold text-ink">{productTitle(a.product)}</div>
              <div className="text-xs text-ink-muted">{new Date(a.created_at).toLocaleDateString()} · {a.id.slice(0, 8)}</div>
            </div>
            <div className="md:col-span-2 text-sm text-ink">{fmt(a.amount)}</div>
            <div className="md:col-span-2 text-sm text-ink">{a.term_months} mo</div>
            <div className="md:col-span-2">
              {a.risk_band && <span className={`rounded-full border px-2 py-0.5 text-xs ${RISK_BADGE[a.risk_band]}`}>{a.risk_band}</span>}
            </div>
            <div className="md:col-span-2">
              <span className={`rounded-full border px-2 py-0.5 text-xs ${STATUS_BADGE[a.status]}`}>{STATUS_LABEL[a.status]}</span>
              {a.admin_notes && <div className="mt-1 text-xs text-ink-muted">Note: {a.admin_notes}</div>}
            </div>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}
